import {
  SET_CAR_ACTIVE_STATE
} from '../constants'

const initialState = {
  isActive: true
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CAR_ACTIVE_STATE:
      return {
        isActive: action.isActive
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/car.js